import type { ReactNode } from "react";

type ReferencesSectionHeaderProps = {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
};

/**
 * Единый заголовок вкладок раздела «Справочники» в админке:
 * заголовок уровня h4, подсказка (text-xs muted), блок действий справа.
 */
export function ReferencesSectionHeader({
  title,
  description,
  actions,
}: ReferencesSectionHeaderProps) {
  return (
    <div className="flex justify-between items-start gap-4">
      <div className="min-w-0 flex-1">
        <h4 className="text-lg font-medium text-foreground">{title}</h4>
        {description != null && description !== false && (
          <p className="text-xs text-muted-foreground mt-1 max-w-[min(100%,52rem)] leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {actions != null && actions !== false ? (
        <div className="flex flex-wrap gap-2 justify-end shrink-0">{actions}</div>
      ) : null}
    </div>
  );
}
